import App from 'App';
import PrivateRoute from 'components/PrivateRoute';
import MainLayout from 'layouts/MainLayout';
import Auth from 'pages/auth';
import { CreateBlock } from 'pages/block/create-block';
import { EditBlock } from 'pages/block/edit-block';
import { DataSources } from 'pages/data-sources';
import { Reports } from 'pages/reports';
import { NotFound } from 'pages/not-found';
import { Report } from 'pages/report';
import { createBrowserRouter } from 'react-router-dom';
import { RouteNamesEnum } from 'types';
import Folder from 'pages/data-sources/Folder';
import { Upload } from 'pages/data-sources/upload';
import { PDF } from 'pages/report/pdf';
import EditReport from 'pages/report/edit';

export const APP_ROUTES = [
  {
    path: RouteNamesEnum.REPORTS,
    element: <Reports />,
  },
  {
    path: RouteNamesEnum.DATASOURCES,
    element: <DataSources />,
  },
  {
    path: `${RouteNamesEnum.DATASOURCES}/folder/:id`,
    element: <Folder />,
  },
  {
    path: `${RouteNamesEnum.DATASOURCES}/upload`,
    element: <Upload />,
  },
  // {
  //   path: RouteNamesEnum.SAMPLES,
  //   element: <Samples />,
  // },
  {
    path: `${RouteNamesEnum.REPORTS}/:id`,
    element: <Report />,
  },
  {
    path: `${RouteNamesEnum.REPORTS}/:id/edit`,
    element: <EditReport />,
  },
  {
    path: `${RouteNamesEnum.BLOCKS}/:id/create`,
    element: <CreateBlock />,
  },
  {
    path: `${RouteNamesEnum.BLOCKS}/:reportId/edit/:blockId`,
    element: <EditBlock />,
  },
];

export const PDF_ROUTES = [
  {
    path: `${RouteNamesEnum.REPORTS}/:id/pdf`,
    element: <PDF />,
  },
];

export const PUBLIC_ROUTES = [
  {
    path: `*`,
    element: <NotFound />,
  },
  {
    path: RouteNamesEnum.AUTH,
    element: <Auth />,
  },
];

export const routes = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        element: (
          <PrivateRoute>
            <MainLayout />
          </PrivateRoute>
        ),
        children: APP_ROUTES,
      },
      ...PUBLIC_ROUTES,
      {
        element: <PDF />,
        children: PDF_ROUTES,
      },
    ],
  },
]);
